import walletProductDetailDialogMessages from '../../../messages/wallet/wallet-product-detail-dialog.messages';
import { Column } from '../../column';
import { ManagedFundsProductUnderlying } from '../details/product-underlying';

export const underlyingMFPColumns: Column<ManagedFundsProductUnderlying>[] = [
  {
    headerLabel: walletProductDetailDialogMessages.detailUnderlyingProduct,
    key: 'productName',
    type: 'string',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailUnderlyingAmount,
    key: 'quantity',
    type: 'number',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailUnderlyingMediumPrice,
    key: 'averagePurchasePrice',
    type: 'amount',
  },
  {
    headerLabel:
      walletProductDetailDialogMessages.detailUnderlyingMFMediumChange,
    key: 'averagePurchaseExchange',
    type: 'number',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailUnderlyingMFRate,
    key: 'rate',
    type: 'number',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailUnderlyingMarketPrice,
    key: 'marketPrice',
    type: 'amount',
  },
  {
    headerLabel:
      walletProductDetailDialogMessages.detailUnderlyingMarketExchange,
    key: 'marketExchange',
    type: 'number',
  },
  {
    headerLabel: walletProductDetailDialogMessages.detailUnderlyingCountervalue,
    key: 'equivalent',
    type: 'amount',
  },
  {
    headerLabel:
      walletProductDetailDialogMessages.detailUnderlyingMFPercentageIncrease,
    key: 'incPercentage',
    type: 'percentage',
  },
  {
    headerLabel:
      walletProductDetailDialogMessages.detailUnderlyingMFPercentageRiskCoefficient,
    key: 'riskCoefficientPercentage',
    type: 'percentage',
  },
];
